import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class NumbersAnimations {
    constructor() {
        this.items = document.querySelectorAll(".block-numbers .number");
        if (this.items.length) {
            this.init();
        }
    }

    init() {
        this.items.forEach((item) => {
            const targetValue = parseFloat(item.getAttribute("data-target")) || 0;
            const unit = item.getAttribute("data-unit") || "";
            const sign = item.getAttribute("data-sign") || "";
            const decimals = this.getDecimals(Math.abs(targetValue));

            const startValue = targetValue < 0 ? -0 : 0;

            gsap.fromTo(
                item,
                { innerHTML: startValue },
                {
                    innerHTML: targetValue,
                    duration: 2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: item,
                        start: "top bottom-=15%",
                        toggleActions: "play none none none",
                    },
                    onUpdate: function () {
                        const value = parseFloat(this.targets()[0].innerHTML);
                        const displaySign = sign === '+' ? '+' : '';
                        item.innerHTML = displaySign + value.toFixed(decimals) + unit;
                    },
                }
            );
        });
    }

    /**
     * Retourne le nombre de décimales d'un nombre
     */
    getDecimals(number) {
        const parts = number.toString().split(".");
        return parts.length > 1 ? parts[1].length : 0;
    }
}


